var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "52px",
    viewBox: "0 0 30 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-requisition-delivery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Marker-/-Requisition-Delivery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0776014,1 C17.3661572,1 17.6123194,1.09943126 17.8146451,1.30175699 C17.9835967,1.47070856 18.0833242,1.66957437 18.1091269,1.90050486 L18.1091269,1.90050486 L18.1178196,8.02880658 L21.9512052,8.02880658 C22.1778035,8.02880658 22.3762154,8.0655431 22.5346937,8.17359654 C22.6957831,8.28343021 22.8052463,8.45849063 22.8916291,8.6744477 C22.9763945,8.88636119 23.0196335,9.08489355 22.9919842,9.27271795 L22.9919842,9.27271795 L18.94218,13.5536629 C22.1372466,14.4749341 24.8595348,16.4882289 26.6634904,19.1564603 C28.1396355,21.339827 29,23.9621968 29,26.7826087 C29,31.9624999 24.2445167,39.845697 14.9991129,50.4798558 C5.75488737,39.844709 1,31.9621753 1,26.7826087 C1,23.9621968 1.86036454,21.339827 3.33650962,19.1564603 C5.14094033,16.4875262 7.8641873,14.4738737 11.0603444,13.5529352 L11.0603444,13.5529352 L7.31175111,9.80465101 C7.15774336,9.65064326 7.04877825,9.48831897 7.01323808,9.30351004 C6.97541974,9.10685469 7.01896928,8.89795167 7.10837087,8.6744477 C7.1902936,8.46964087 7.29294059,8.30201707 7.44061663,8.19126004 L7.44061663,8.19126004 L11.8835979,8.02692825 L11.8835979,2.03880071 C11.8835979,1.75024495 11.9830291,1.50408271 12.1853549,1.30175699 C12.3543341,1.13277772 12.5532374,1.03304525 12.7842163,1.00726254 L12.7842163,1.00726254 Z",
    id: "Combined-Shape",
    stroke: "#1F5BC0",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1F5BC0",
    cx: 15,
    cy: 27,
    r: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionDelivery);
export default __webpack_public_path__ + "static/media/map-marker-requisition-delivery.fb6d2fdfa95f16fd3b32ab60f4e64080.svg";
export { ForwardRef as ReactComponent };